import { render } from "./UGCPanelMonsterForm.vue?vue&type=template&id=12f57324"
import script from "./UGCPanelMonsterForm.vue?vue&type=script&lang=js"
export * from "./UGCPanelMonsterForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__